import { BackgroundDesignator, colorsToBackgroundColorClass } from "components/DesignSystem"

/**
 *  Determine the CSS class that would correspond with certain
 *  background designator. The class will be compatible with our
 *  Design System and our tailwind configuration.
 */
export function determineBackgroundClass(designator: BackgroundDesignator) {
  if (designator === "inherit") {
    return "bg-inherit"
  }

  if (designator === "transparent") {
    return "bg-transparent"
  }

  return colorsToBackgroundColorClass[designator]
}
